import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";

export default function GoogleMerchantAccess(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  const [userGrantAccess, setUserGrantAccess] = useState(
    props.teamAccess["Google Merchant"]["Full"] == "1" || props.teamAccess["Google Merchant"]["Restricted"] == "1"
  );
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();
  const [validated, setValidated] = useState(false);
  useEffect(() => {
    if (props.teamAccess["Google Merchant"]["Restricted"] == "1" || props.teamAccess["Google Merchant"]["Full"] == "1") {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });
  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col className="px-0" md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Google Merchant Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will grant access to Google Merchant. Please {/*watch the video for the detailed instruction on how to grant access properly, and
              then */}check the box to indicate the access level granted. It's important to note that checking the access level boxes are solely for reference, and
              will not perform any actions in regards to granting access to your account.
            </p>
          </div>
        </Col>
      </Row>

      <Row className="mb-5 justify-content-center">
        <Col className="mr-0 pr-5" lg={5}>
            {/* <Row className="my-4  justify-content-center">
              <Col md={6}>
                <p className="f14  visby-bold light-primary">Email to grant access to:</p>
                <p className="f16 primary">support@digitalposition.com</p>
              </Col>
            </Row> */}

          <Row className="justify-content-center">
            <Col md={6}>
              <div className="pb-2">
                <CustomFormCheck
                  id="ob-google-merchant"
                  name="ob-google-merchant"
                  label="Google Merchant access granted"
                  checked={userGrantAccess}
                  onChange={(e) => {
                    setUserGrantAccess(!userGrantAccess);
                  }}
                />
              </div>
              <div className="pb-1 pl-3">
                <p className="f14 visby-bold light-primary">Access level granted:</p>
              </div>
              <div className="pb-1 pl-3 ">
                <CustomFormCheck
                  id="ob-google-merchant-admin"
                  name="google-merchant-admin"
                  label="Full"
                  disabled={!userGrantAccess}
                  checked={props.teamAccess["Google Merchant"]["Full"] == "1"}
                  onChange={(e) => {
                    let accessChecked = props.teamAccess;
                    accessChecked["Google Merchant"]["Restricted"] = "0";
                    accessChecked["Google Merchant"]["Full"] = props.teamAccess["Google Merchant"]["Full"] == "1" ? "0" : "1";
                    props.setTeamAccess({ ...accessChecked });
                  }}
                />
              </div>
              <div className="pb-1 pl-3 ">
                <CustomFormCheck
                  id="ob-google-merchant-standard"
                  name="google-merchant-standard"
                  label="Restricted"
                  disabled={!userGrantAccess}
                  checked={props.teamAccess["Google Merchant"]["Restricted"] == "1"}
                  onChange={(e) => {
                    let accessChecked = props.teamAccess;
                    accessChecked["Google Merchant"]["Full"] = "0";
                    accessChecked["Google Merchant"]["Restricted"] = props.teamAccess["Google Merchant"]["Restricted"] == "1" ? "0" : "1";
                    props.setTeamAccess({ ...accessChecked });
                  }}
                />
                <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
              </div>
            </Col>
          </Row>
        </Col>
        {/* <Col lg={5} className="mt-3">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/aYXKRpCTJpc"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ maxWidth: "100%" }}></iframe>
        </Col> */}
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
